const initial_state = {
  prompt_text: "",
  rows_text_area: 1,
  max_rows_text_area: 7,
  sini_data_update: 0,
  menu_sidebar: "old_menu", //chat  | history | old_menu
  request_id: "",
  convert_text_to_number_object: {},
  convert_progress: "pending", //pending | success | failed
  current_chat: {},
  sini_data_history: [],
  chat_list: [],
  token_open_ai: 128000,
  estimated_token_used: 0,

  /*
  chat_list: [
  {
    role: String,
    //role: system | user | assistant

    content: String,
    //content: text message

    layer_action_list: Array,
  },
]
  */
};

export default function sini_data_reducer(state = initial_state, action) {
  switch (action.type) {
    case "set_value_sini_data":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case "push_value_sini_data":
      return {
        ...state,
        [action.payload.key]: [
          ...state[action.payload.key],
          action.payload.value,
        ],
      };
    case "delete_value_sini_data": {
      const { key, value } = action.payload;

      const nextArray = state[key].filter((item) => item !== value);

      console.log("Sebelum filter:", state[key]);
      console.log("Value yang dihapus:", value);
      console.log("Hasil setelah filter:", nextArray);

      console.log("[delete_value_sini_data]", {
        key,
        value,
        prevArray: state[key],
        nextArray,
      });

      return {
        ...state,
        [key]: nextArray,
      };
    }

    case "sini_data_update":
      return {
        ...state,
        sini_data_update: state.sini_data_update + 1,
      };

    default:
      return state;
  }
}
